"use client";

import React, { useState } from "react";
import Button from "@/components/primitives/button";
import { scrollToSection } from "@/utils";
import Icon from "../primitives/icon";

interface TableOfContentsItem {
  id: string;
  label: string;
}

interface MobileTableOfContentsProps {
  items: TableOfContentsItem[];
  headerOffset?: number;
}

export default function MobileTableOfContents({
  items,
  headerOffset = 120,
}: MobileTableOfContentsProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleScrollToSection = (id: string) => {
    scrollToSection(id, headerOffset);
    // Collapse the TOC after navigation
    // setIsExpanded(false);
  };

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="bg-surface-700 rounded-xl">
      {/* Header - always visible */}
      <button
        onClick={toggleExpanded}
        className="flex justify-between items-center hover:bg-surface-600 px-6 py-6 w-full text-left transition-colors"
        aria-expanded={isExpanded}
        aria-controls="mobile-toc-content"
      >
        <h4 className="flex items-center gap-2 text-secondary-200 text-title-lg-medium uppercase">
          <Icon name="list-bullets" /> Table of Contents
        </h4>
        <div
          className={`transition-transform fill-primary-200 ${
            isExpanded ? "rotate-180" : ""
          }`}
        >
          <Icon name="caret-down" size="sm" />
        </div>
      </button>

      {/* Collapsible content */}
      <div
        id="mobile-toc-content"
        className={`overflow-hidden transition-all duration-300 ${
          isExpanded ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="px-4 pb-4 border-secondary-700 border-t">
          <ul className="flex flex-col gap-3 pt-4">
            {items.map((item) => (
              <li key={item.id}>
                <Button
                  variant="underline"
                  className="justify-start w-full !text-secondary-300 text-body-sm hover:!text-primary text-left transition-colors"
                  onClick={() => handleScrollToSection(item.id)}
                >
                  {item.label}
                </Button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
